import Section from "../UI/Section";
import TaskItem from "./TaskItem";
import classes from "./Tasks.module.css";

const Tasks = (props) => {
  let content = <h2>Er zijn geen taken gevonden. Voeg een taak toe!</h2>;

  if (props.taken.length > 0) {
    let taskList = props.taken.map((taak) => (
      <TaskItem
        key={taak.id}
        id={taak.id}
        taak={taak.taak}
        status={taak.status}
        begindatum={taak.begindatum}
        einddatum={taak.einddatum}
      />
    ));

    content = (
      <table>
        <thead>
          <tr>
            <th>Taak</th>
            <th>Status</th>
            <th>Begindatum</th>
            <th>Eindatum</th>
          </tr>
        </thead>
        <tbody>{taskList}</tbody>
        <tfoot>
          <tr>
            <td>Taak</td>
            <td>Status</td>
            <td>Begindatum</td>
            <td>Eindatum</td>
          </tr>
        </tfoot>
      </table>
    );
  }

  if (props.error) {
    content = <button onClick={props.onFetch}>Try again</button>;
  }

  if (props.loading) {
    content = "Loading tasks...";
  }

  return (
    <Section>
      <div className={classes.container}>{content}</div>
    </Section>
  );
};

export default Tasks;
